/// <reference path="Assistant.ts" />

namespace TerminalApp {

    export class BarcodePrintAssistant extends Assistant {
        bc_menu = document.createElement("div");
        template_menu = document.createElement("div");
        qty_input: HTMLInputElement;
        submit_button: HTMLElement;
        template_content: HTMLElement;
        resultCount = 0;
        ItemId: string;
        colli_qty: number;
        bc: string;
        template_id: string;

        constructor() {
            super();

            // Build the quantity menu
            this.bc_menu.innerHTML = `
                <h1>${SP.Localize("sentance_choose_amount")}</h1>
                <input type="number" value="1" autocomplete="off" tabindex="1" style="margin-bottom:5px;" class="qty_input search_input form-control">
                <div class="btn noselect grad-green"><span class="action">${SP.Localize("word_print")}</span></div>
            `;
            this.qty_input = this.bc_menu.querySelector(".qty_input");
            this.submit_button = this.bc_menu.querySelector(".btn");
            this.submit_button.addEventListener("click", async () => {
                const amt = parseInt(this.qty_input.value);
                if (amt) {
                    const result = await SP.get<any>(
                        `/api/v1/item/printbarcode?printer=${App_Settings.terminalSettings.etiquette_printer}&id=${this.ItemId}&barcode=${encodeURIComponent(this.bc)}&colli=${this.colli_qty}&copies=${amt}&template=${this.template_id}`
                    );
                    if (result.status !== 200) {
                        await SP.alertX(result.msg);
                    } else {
                        this.close();
                    }
                }
            });

            // Build the template menu
            this.template_menu.innerHTML = `
                <h1>${SP.Localize("sentance_select_template")}</h1>
                <div></div>
            `;
            this.template_content = this.template_menu.querySelector("div");

            // Initially hide both menus
            this.bc_menu.style.display = "none";
            this.template_menu.style.display = "none";

            // Append template menu first, then quantity menu
            this.container.appendChild(this.template_menu);
            this.container.appendChild(this.bc_menu);
        }

        openQtyMenu(templateId: string) {
            // Hide the template menu, show the quantity menu
            this.template_menu.style.display = "none";
            this.bc_menu.style.display = "block";
            this.qty_input.focus();
            this.qty_input.value = "1";
            this.template_id = templateId;
        }

        async openTemplateMenu(CustomerId: string) {
            // Show the template menu
            this.template_menu.style.display = "block";

            // Get templates
            const templates = await SP.Data.BarcodeTemplates.getBarcodeTemplates(CustomerId);

            // If only one template is available, open the quantity menu immediately
            if (templates.length === 1) {
                this.openQtyMenu(templates[0].id);
                return;
            }

            this.template_content.innerHTML = "";
            // Otherwise, list out templates as clickable buttons
            for (const template of templates) {
                const div = document.createElement("div");
                div.classList.add("btn", "noselect", "grad-green");
                div.innerHTML = `<span class="action">${template.name}</span>`;
                div.addEventListener("click", () => {
                    this.openQtyMenu(template.id);
                });
                this.template_content.appendChild(div);
            }
        }

        async open(CustomerId: string, ItemId: string, bc: string, colli_qty: number) {
            this.ItemId = ItemId;
            this.bc = bc;
            this.colli_qty = colli_qty;
            this.container.style.display = "block";
            this.template_menu.style.display = "none";
            this.bc_menu.style.display = "none";

            // Always show the template menu first
            this.openTemplateMenu(CustomerId);

            console.log("BarcodePrintAssistant open");
        }

        close() {
            super.close();
        }
    }
}
